export default function Messe() {
    return <h1>Messe</h1>
} 